import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.server.update;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'SERVER_UPDATE',
	url: '/server/update.json',
});

export { actions, reducer, sagas, selectors };
